import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { WhitelabelConfig } from '@xarvio/frontend-core-state/lib/auth/hooks/useWhitelabel/useWhitelabel';
import {
  countrySelector,
  localeSelector,
} from '@xarvio/frontend-core-state/lib/intl/selectors';
import { selectedFarmUuidSelector } from '@xarvio/frontend-core-state/lib/selectedFarm/selectors';
import { userSettingsLastFarmSelectedUuidSelector } from '@xarvio/frontend-core-state/lib/users/settings/selectors';

import { getPagesUrl, GetPagesUrlProps } from './utils/getPagesUrl';

export function useGetPageUrl<TQueryParameters extends Record<string, string>>(
  props?: GetPagesUrlProps<TQueryParameters>,
  whitelabelConfig?: WhitelabelConfig,
) {
  let farmUuid = useSelector(selectedFarmUuidSelector);
  let locale = useSelector(localeSelector);
  let country = useSelector(countrySelector);

  if (props?.farmUuid) {
    farmUuid = props.farmUuid;
  }
  if (props?.locale) {
    locale = props.locale;
  }
  if (props?.country) {
    country = props.country;
  }

  return getPagesUrl(
    {
      ...props,
      farmUuid,
      locale,
      country,
    },
    whitelabelConfig,
  );
}

export function useGeneratePageUrl<
  TQueryParameters extends Record<string, string>,
>() {
  const selectedFarmUuid = useSelector(selectedFarmUuidSelector);
  const userSettingsLastFarmSelectedUuid = useSelector(
    userSettingsLastFarmSelectedUuidSelector,
  );
  const locale = useSelector(localeSelector);
  const country = useSelector(countrySelector);

  return useCallback(
    (props?: GetPagesUrlProps<TQueryParameters>) =>
      getPagesUrl({
        ...props,
        farmUuid:
          props?.farmUuid ??
          selectedFarmUuid ??
          userSettingsLastFarmSelectedUuid,
        locale: props?.locale ?? locale,
        country: props?.country ?? country,
      }),
    [country, locale, selectedFarmUuid, userSettingsLastFarmSelectedUuid],
  );
}
